import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../apiClient";

export const generatePayload = (classData, member_id, processed_date) => {
  return {
    classes: Object.values(classData).map(val => {
      return {
        id: val.id,
        class: val.class,
      };
    }),
    member_id,
    processed_date,
  };
};

export const postMemberClassesAssignAndUpdate = data => {
  return api.post(`admin/member-class-assign-and-update`, data);
};

export const postMemberClassesAssignAndUpdateQueryOptions = (data, meta) => {
  return queryOptions({
    queryKey: ["member-class-assign-and-update", data],
    queryFn: () => postMemberClassesAssignAndUpdate(data),
    meta,
  });
};

export const usePostMemberClassesAssignAndUpdateMutation = ({
  mutationConfig,
}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (data, ...args) => {
      await onSuccess?.(data, ...args);
      queryClient.invalidateQueries();
    },
    ...restConfig,
    mutationFn: postMemberClassesAssignAndUpdate,
  });
};
